import {useCallback, useEffect, useState} from "react";
import {useDashboardContext} from "../dashboardContextProvider";
import {DashboardVejledersamtaleModel} from "../dashboardVejledersamtaler/DashboardVejledersamtaleModel";
import {VejledersamtaleStatusEnum} from "../../vejledning/vejledersamtaler/VejledersamtaleStatusEnum";
import {VejledersamtaleEnum} from "../../vejledning/vejledersamtaler/vejledersamtaleModel";
import {DashboardForloebModel} from "../dashboardUddannelseslaeger/DashboardForloebModel";
import {DashboardUddannelsesplanStatusEnum} from "../../vejledning/uddannelsesplan/DashboardUddannelsesplanStatusEnum";
import {DashboardUddannelsesplanModel} from "../dashboardUddannelsesplaner/DashboardUddannelsesplanModel";
import {getEnums} from "../../../core/helpers/enumToList";
import {DashboardOpmaerksomhedspunkterEnum} from "./DashboardOpmaerksomhedspunkterEnum";
import {removeWhiteSpace} from "../../../core/helpers/stringHelper";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {nameof} from "ts-simple-nameof";

import {InitialFilterModel} from "../../../core/components/reactTable/ReactBaseTable";
import {useHistory} from "react-router-dom";
import {RoutePaths} from "../../../infrastructure/routes";
import {DashboardListForloebModel} from "../dashboardList/models/DashboardListForloebModel";

const useDashboardOpmaerksomhedspunkter = () => {
    const [vejledersamtalerIntoOverskredet, setVejledersamtalerIntoOverskredet] = useState<DashboardVejledersamtaleModel[]>([]);
    const [vejledersamtalerJusterendeOverskredet, setVejledersamtalerJusterendeOverskredet] = useState<DashboardVejledersamtaleModel[]>([]);
    const [vejledersamtalerAfsluttendeOverskredet, setVejledersamtalerAfsluttendeOverskredet] = useState<DashboardVejledersamtaleModel[]>([]);
    const [forloebManglerEvaluering, setForloebManglerEvaluering] = useState<DashboardForloebModel[]>([]);
    const [uddannelsesplanerIkkeOprettet, setUddannelsesplanerIkkeOprettet] = useState<DashboardUddannelsesplanModel[]>([]);

    const {state} = useDashboardContext()
    const enums = getEnums(DashboardOpmaerksomhedspunkterEnum);
    const history = useHistory();

    useEffect(() => {
        const introsamtaler = state.vejledersamtaler.filter(x => x.vejledersamtaleType === VejledersamtaleEnum.Introduktion);
        const introduktionOverskredet = introsamtaler.filter(y => y.status === VejledersamtaleStatusEnum.OverskredetFrist);
        setVejledersamtalerIntoOverskredet(introduktionOverskredet);

        const justerendeSamtaler = state.vejledersamtaler.filter(x => x.vejledersamtaleType === VejledersamtaleEnum.Justering || x.vejledersamtaleType === VejledersamtaleEnum.Anden);
        const justerendeSamtalerOverskredet = justerendeSamtaler.filter(y => y.status === VejledersamtaleStatusEnum.OverskredetFrist || y.status === VejledersamtaleStatusEnum.EndnuIkkePlanlagt);
        setVejledersamtalerJusterendeOverskredet(justerendeSamtalerOverskredet);

        const afsluttendeSamtaler = state.vejledersamtaler.filter(x => x.vejledersamtaleType === VejledersamtaleEnum.Afsluttende);
        const afsluttendeSamtalerOverskredet = afsluttendeSamtaler.filter(y => y.status === VejledersamtaleStatusEnum.OverskredetFrist);
        setVejledersamtalerAfsluttendeOverskredet(afsluttendeSamtalerOverskredet);

        const uddannelseslaeger = state.uddannelseslaeger;
        setForloebManglerEvaluering(uddannelseslaeger.filter(x => (x.evalueretDato === null || x.evalueretDato === undefined) && x.forloebSlutDato <= new Date().addMonths(1)));

        setUddannelsesplanerIkkeOprettet(state.uddannelsesplaner.filter(x => x.status === DashboardUddannelsesplanStatusEnum.EndnuIkkeOprettet));
    }, [history, state.uddannelseslaeger, state.uddannelsesplaner, state.vejledersamtaler])


    const GetNavigationCallback = useCallback((enumItem: DashboardOpmaerksomhedspunkterEnum) => {
        switch (enumItem) {
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerVejleder:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.vejlederNavne).toLowerCase(),
                                initialFilterValue: Localizer.dashboard_tildelVejleder()
                            },
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAktivitetPaaUddannelsesplan:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.foersteUddannelsesplanStatus).toLowerCase(),
                                initialFilterValue: Localizer.global_endnuIkkeOprettet()
                            },
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtEvaluereForloeb:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.evalueret).toLowerCase(),
                                initialFilterValue: false
                            },
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.mdrOgDageTilbage).toLowerCase(),
                                initialFilterValue: ["0", undefined]
                            },
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtFaaGodkendtForloeb:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.godkendt).toLowerCase(),
                                initialFilterValue: false
                            },
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.mdrOgDageTilbage).toLowerCase(),
                                initialFilterValue: ["0", "30"]
                            }
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarKlarmeldteKompetencer:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.antalKlarmeldteKompetencer).toLowerCase(),
                                initialFilterValue: ["1", undefined]
                            }
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.introVejledersamtaleStatus).toLowerCase(),
                                initialFilterValue: [Localizer.global_overskredetFrist()]
                            }
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.forloebProgress).toLowerCase(),
                                initialFilterValue: [50, undefined]
                            },
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.justerendeVejledersamtaleStatus).toLowerCase(),
                                initialFilterValue: [Localizer.global_endnuIkkePlanlagt(), Localizer.global_overskredetFrist()]
                            },
                        ] as InitialFilterModel[]
                    })
                };
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist:
                return () => {
                    history.push({
                        pathname: RoutePaths.Dashboard({activeTab: removeWhiteSpace(Localizer.dashboard_listView())}).url,
                        state: [
                            {
                                initialFilterId: nameof<DashboardListForloebModel>(x => x.afsluttendeVejledersamtaleStatus).toLowerCase(),
                                initialFilterValue: [Localizer.global_overskredetFrist()]
                            }
                        ] as InitialFilterModel[]
                    })
                };
            default:
                return undefined;
        }
    }, [history]);

    const GetAmountFromOpmaerksomhedsType = useCallback((enumItem: DashboardOpmaerksomhedspunkterEnum): number => {
        switch (enumItem) {
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerVejleder:
                return state.vejledning.length;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAktivitetPaaUddannelsesplan:
                return uddannelsesplanerIkkeOprettet.length;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtEvaluereForloeb:
                return forloebManglerEvaluering.length;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtFaaGodkendtForloeb:
                return state.gamleForloebUdenGodkendelse.length;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarKlarmeldteKompetencer:
                return state.kompetenceKlarmeldinger.length;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist:
                return vejledersamtalerIntoOverskredet.length
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist:
                return vejledersamtalerJusterendeOverskredet.length
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist:
                return vejledersamtalerAfsluttendeOverskredet.length
            default:
                return 0;
        }
    }, [forloebManglerEvaluering.length, state.gamleForloebUdenGodkendelse.length, state.kompetenceKlarmeldinger.length, state.vejledning.length, uddannelsesplanerIkkeOprettet.length, vejledersamtalerAfsluttendeOverskredet.length, vejledersamtalerIntoOverskredet.length, vejledersamtalerJusterendeOverskredet.length]);

    const OpmaerksomhedspunktIsLoading = useCallback((enumItem: DashboardOpmaerksomhedspunkterEnum): boolean => {
        switch (enumItem) {
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerVejleder:
                return state.vejledningIsLoading;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAktivitetPaaUddannelsesplan:
                return state.uddannelsesplanerIsLoading;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtEvaluereForloeb:
                return state.uddannelseslaegerIsLoading;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeManglerAtFaaGodkendtForloeb:
                return state.gamleForloebUdenGodkendelseIsLoading;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarKlarmeldteKompetencer:
                return state.kompetenceKlarmeldingerIsLoading;
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetIntroVejledersamtaleFrist:
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetJusterendeVejledersamtaleFrist:
            case DashboardOpmaerksomhedspunkterEnum.UddannelseslaegeHarOverskredetAfsluttendeVejledersamtaleFrist:
                return state.vejledersamtalerIsLoading
            default:
                return true;
        }
    }, [state.gamleForloebUdenGodkendelseIsLoading, state.kompetenceKlarmeldingerIsLoading, state.uddannelseslaegerIsLoading, state.uddannelsesplanerIsLoading, state.vejledersamtalerIsLoading, state.vejledningIsLoading]);


    return {
        opmaerksomhedspunkter: enums,
        GetAmountFromOpmaerksomhedsType: GetAmountFromOpmaerksomhedsType,
        OpmaerksomhedspunktIsLoading: OpmaerksomhedspunktIsLoading,
        GetNavigationCallback: GetNavigationCallback
    }
}
export default useDashboardOpmaerksomhedspunkter;
